// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"570":"6abfd7bd","3583":"f1dc0515","4992":"6abfd7bd","7248":"f1dc0515"}[chunkId] + ".chunk.css";
};